<template>
  <v-navigation-drawer
    v-model="modifyMode.show"
    class="z-index-5"
    disable-resize-watcher
    app
    clipped
    right
    :width="modifyMode.width"
  >
    <component :is="pageName"></component>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex'

import ContentEdit from '@/components/elements/block/ContentEdit.vue'
import BriefEdit from '@/components/elements/block/BriefEdit.vue'

export default {
  name: 'DocumentEdit',

  components: { BriefEdit, ContentEdit },

  data() {
    return {}
  },

  computed: {
    ...mapState('common', ['modifyMode']),
    ...mapState('document', ['currMenuObj']),
    pageName() {
      return this.currMenuObj.menuId === 1 ? 'BriefEdit' : 'ContentEdit'
    }
  },

  watch: {},

  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
